import { CopyIcon, DropdownCheckIcon } from "../../../Icons";
// import Input from "../../../Input";
import Label from "../../../Label";

const BankDetailsInput = ({ label, value, name, onCopy, isCopied }) => {
  return (
    <div className="bank-details-input-wrapper">
      <Label
        htmlFor={name}
        className="bank-details-input-label"
        text={label}
      />
      {/* <Input
        type="text"
        name={name}
        id={name}
        value={value}
        className="bank-details-input-field"
        isDisabled={true}
      /> */}
      
      <div name={name} id={name} className="bank-details-input-field">
        {value}
      </div>
      
      <div onClick={onCopy} className="bank-details-input-copy">
        {isCopied ? (
          <DropdownCheckIcon className="h-6 w-6" />
        ) : (
          <CopyIcon className="h-6 w-6" />
        )}
      </div>
    </div>
  );
};
export default BankDetailsInput;
